<template>
  <section class="mission-statement-component-container">
    <b-icon-x-square-fill @click="hideStatement()" />

    <b-badge variant="secondary">
      {{ missionFocus | typeTranslate }}
    </b-badge>

    <div
      class="mission-info"
      v-if="missionFocus.system !== 'News'"
    >
      <div
        class="mission-statement product-statement"
        v-if="missionFocus.type!='del'"
      >
        <img
          alt="圖片已被修改或刪除"
          :src="missionFocus.Statement.imagePath"
          onerror="this.onerror=null;
					this.src=`./image/${this.src.split('/').slice(-1)}`;"
        />
        <div>
          <h1>{{ missionFocus.Statement.name_CH }}</h1>
          <h3>{{ missionFocus.Statement.name_EN }}</h3>
          <i>{{ categoriesObject[missionFocus.Statement.cateId] }}</i>
          <p> Size: {{ missionFocus.Statement.size || '無定義尺寸' }}</p>
        </div>
      </div>
      <div v-else>
        <h2>欲刪除品項：{{ missionFocus.product }}</h2>
      </div>
    </div>

    <div
      class="mission-info"
      v-else
    >
      <div
        class="mission-statement news-statement"
        v-if="missionFocus.type!='del'"
      >
        <img
          alt="圖片已被修改或刪除"
          :src="missionFocus.Statement.imagePath"
          onerror="this.onerror=null;
					this.src=`./image/${this.src.split('/').slice(-1)}`;"
        />
        <div>
          <h4>{{ missionFocus.Statement.news_CH }}</h4>
          <p>{{ missionFocus.Statement.news_EN }}</p>
          <b-button v-b-modal.modal-1>顯示消息內容</b-button>

          <b-modal
            id="modal-1"
          >
            <template #modal-header>
              <div>
                <h5>
                  {{ missionFocus.Statement.news_CH }}
                </h5>
                <b-badge>
                  {{ newsCategoryDict[missionFocus.Statement.categoryId].name_CH }}
                </b-badge>
              </div>
            </template>
            <b>中文內容：</b><br>
            <span
              class="my-4"
              v-html="missionFocus.Statement.desc_CH.replace(/\n/g,'<br/>')"
            />
            <hr>
            <b>英文內容：</b><br>
            <span
              class="my-4"
              v-html="missionFocus.Statement.desc_EN.replace(/\n/g,'<br/>')"
            />
          </b-modal>
        </div>
      </div>
      <div v-else>
        <h2>欲刪除品項：{{ missionFocus.product || missionFocus.news}}</h2>
      </div>
    </div>

    <b-form v-if="missionFocus.state=='pending'">
      <b-form-group
        id="input-group-1"
        label="任務單備註"
        label-for="input-1"
      >
        <b-form-textarea
          id="textarea"
          v-model="comment"
          placeholder="Enter comment..."
          rows="3"
          max-rows="6"
        />
      </b-form-group>

      <div>
        <b-button
          @click="submitData('approve')"
          variant="primary"
        >
          核准
        </b-button>
        <b-button
          @click="submitData('turnback')"
          variant="warning"
        >
          退回
        </b-button>
        <b-button
          @click="submitData('delete')"
          variant="danger"
        >
          刪除任務
        </b-button>
      </div>
    </b-form>
  </section>
</template>

<script>
  import { mapState, mapActions, mapGetters } from "vuex";
  import firebase from "../store/modules/firebase";

  export default {
    data() {
      return {
        comment: "",
      };
    },
    props: {
      hideStatement: Function,
      missionFocus: Object,
    },
    computed: {
      ...mapState("login", ["user"]),
      ...mapState("backend", ["categories", "products", "news"]),
      ...mapGetters('backend', ['newsCategoryDict']),

      categoriesObject: function () {
        if (this.categories.length) {
          console.log(this.categories);
          return this.categories.reduce((accumulator, cate) => {
            return { [cate.id]: cate.name_CH, ...accumulator };
          }, {});
        }
        return {};
      },
    },
    methods: {
      ...mapActions("backend", ["signMission"]),

      submitData: function (approveType) {
        const { id, ...mission } = this.missionFocus;
        const oldStatement = mission.system === "Product"
          ? this.products.filter(item => item.id === mission.productID)[0]
          : this.news.filter(item => item.id === mission.itemID)[0]

        mission.state = approveType;
        if (["approve", "delete"].includes(approveType)) {
          mission.date = new Date().getTime();
        }
        if (approveType === "delete") {
          if (!oldStatement || oldStatement.image !== mission.Statement.image) this.deleteFile(mission);
        }
        mission.comment = this.comment;
        mission.supervisor = this.user.name;

        this.signMission({ id: id, mission: mission });
        this.hideStatement();
      },
      deleteFile: async (mission) => {
        const { system, itemID, id, Statement } = mission;
        const ref = firebase.storage().ref(`images/${system.toLowerCase() + "s"}/${itemID || id}/${Statement.image}`);
        await ref.delete();
      }
    },
    filters: {
      typeTranslate: function (missionFocus) {
        const { type, system = "Product" } = missionFocus;
        const systemName = system === "Product" ? "產品" : "消息";
        const typeDict = {
          add: `${systemName}上架`,
          edit: `${systemName}資訊修改`,
          del: `${systemName}刪除`,
        };
        return typeDict[type];
      },
    },
  };
</script>
